import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { AppBar, Toolbar, Typography, makeStyles, Button } from "@material-ui/core";
import '../../../styles/navbar.scss';
import Modalpopup from '../../pages/Modalpopup/Modalpopup';
import { useGAEventsTracker } from "../../../util/gtag";
import { Link as Li } from 'react-router-dom';
import MenuIcon from '@material-ui/icons/Menu';
import Accordion from '@material-ui/core/Accordion';
import { split } from 'lodash';
import { useHistory } from 'react-router-dom';
import config from "../../config/config";

const useStyles = makeStyles(() => ({
    title: {
        flexGrow: 1,
    },
    header: {
        backgroundColor: '#fff',
        color: "black",
        "@media (max-width: 900px)": {
            paddingLeft: 0,
        },
    },
    logo: {
        fontFamily: "Work Sans, sans-serif",
        fontWeight: 600,
        color: "black",
        textAlign: "left",
        width: '100%',
    },
    menuButton: {
        fontWeight: 700,
        size: "18px",
        marginLeft: "38px",
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
    },
}));

export default function NavbarRealtor(props) {
    const GAEventTracker = useGAEventsTracker(window.location.pathname);
    const GAEventTrackerContact = useGAEventsTracker(window.location.pathname + "/Contact Us");
    const GAEventTrackerHowItWorks = useGAEventsTracker(window.location.pathname + "/How It Works");
    const GAEventTrackerFaq = useGAEventsTracker(window.location.pathname + "/FAQs")
    const [openSubmit, setOpenSubmit] = React.useState(false);
    const [drawerstate, setDrawerState] = useState(false)
    const history = useHistory();
    const handleClickOpen2 = () => {
        setOpenSubmit(!openSubmit);
    };
    const { header, logo, toolbar } = useStyles();
    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });
    const { mobileView } = state;
    const handleMobileMenu = (event, state) => {
        event.stopPropagation();
        setDrawerState(state);
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
    };
    const menuClicked = (e) => {
        e.stopPropagation()
    }
    const handleHome = () => {
        setTimeout(() => {
            setDrawerState(!drawerstate)
        }, 100)
    }
    const handleFaqMobile = () => {
        setDrawerState(!drawerstate);
        const url = window.location.href;
        const urlName = new URL(url);
        const urlNamePath = split(urlName.pathname, "/")
        if (urlNamePath[3] === "calculator") {
            history.push(`/lender/${props?.partner?.url_path}`)
            setTimeout(() => {
                let ele = document.getElementById('faq')
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest", })
            }, 200);
        }
    }
    const handleHowItWorks = () => {
        setDrawerState(!drawerstate)
        const url = window.location.href;
        const urlName = new URL(url);
        const urlNamePath = split(urlName.pathname, "/")
        if (urlNamePath[3] === "calculator") {
            history.push(`/lender/${props?.partner?.url_path}`)
            setTimeout(() => {
                let ele = document.getElementById('trade')
                ele.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            }, 200);
        }
    }
    const handleCalculator = () => {
        history.push(`/realtor/${props?.partner?.url_path}/calculator`);
    }
    const mobileNav = () => {
        return (
            <>
                <div className="partner_navbar_mob">
                    <div>
                        {props.pathname && props.pathname.length !== 0 && props.pathname.url_path !== 'wrenews' && props.pathname.url_path !== 'jw&!$329654' ?
                            <div className="partner_navbar_sub_mob">
                                <div><img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '120px', height: '68px', objectFit: 'contain' }}></img></div>
                                <div className="px-2 partner_header_plus mt-1">+</div>
                                <div className="partner_header_logo_calque">
                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                    <img src="/assets/logos/Color_H.png" alt="Logo" width="142px" height="45px"></img>
                                </Li>
                            </div>
                            </div>
                            :
                            <div className="partner_header_logo_calque">
                                <Li to={`/lender/${props?.partner?.url_path}`} onClick={(e) => { GAEventTracker("Home") }}>
                                    <img src="/assets/logos/Color_H.png" alt="Logo" width="130px" height="36px"></img>
                                </Li>
                            </div>
                        }
                    </div>
                    <div>
                        <div onClick={(e) => handleMobileMenu(e, !drawerstate)} onKeyDown={(e) => handleMobileMenu(e, !drawerstate)} style={{ cursor: 'pointer' }} className="d-flex align-items-center justify-content-center">
                            <MenuIcon />
                        </div>
                    </div>
                </div>
                {drawerstate === true ?
                    <div id="mobilemenu" style={{ position: 'absolute', width: '100%', backgroundColor: '#fff', top: '3.5rem', borderTop: '1px solid #eee' }} onClick={menuClicked}>
                        <div id="menuAccordian">
                            <Accordion className="p-2 pl-4">
                                <Li activeclass="active"
                                    to={`/realtor/${props?.partner?.url_path}`}
                                    href={`/realtor/${props?.partner?.url_path}`}
                                    onClick={(e) => { GAEventTracker("Home"); handleHome() }}
                                    spy={true}
                                    smooth="true"
                                    offset={-70}
                                    duration={500}>
                                    Home
                                </Li>
                            </Accordion>
                            <Accordion className="p-2 pl-4">
                                <Link activeclass="active"
                                    to="trade"
                                    spy={true}
                                    smooth="true"
                                    offset={-70}
                                    onClick={(e) => { GAEventTrackerHowItWorks("Header", 1); handleHowItWorks() }}
                                    className=""
                                    duration={500}>
                                    How it works
                                </Link>
                            </Accordion>

                            <Accordion className="p-2 pl-4">
                                <Link activeclass="active"
                                    className="faqs"
                                    to="faq"
                                    spy={true}
                                    smooth="true"
                                    offset={-70}
                                    duration={500}
                                    onClick={(e) => { GAEventTrackerFaq("Header", 1); handleFaqMobile() }}
                                >
                                    FAQs
                                </Link>
                            </Accordion>
                            {/* <Accordion className="p-2 pl-4">
                                <Link activeclass="active"
                                    className="faqs"
                                    to="faq"
                                    spy={true}
                                    smooth="true"
                                    offset={-70}
                                    duration={500}
                                    onClick={(e) => { handleCalculator() }}
                                >
                                    Calculator
                                </Link>
                            </Accordion> */}
                            <Accordion className="p-2 pl-4">
                                <Li activeclass="active"
                                    onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                                >
                                    Contact
                                </Li>
                            </Accordion>
                        </div>
                    </div>
                    : ''
                }
            </>
        )
    };
    const desktopNav = () => {
        return (
            <Toolbar className={toolbar}>
                <div className="col-7 jost-bold" >
                    <Typography variant="h6" component="h1" className={logo}>
                        <div className="login_img d-flex align-items-center justify-content-start">
                            {props?.partner?.url_path === 'cke' ?
                                <>
                                    <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '80px', height: '48px', objectFit: 'contain', }}></img>
                                    <p className="px-2 m-0">+</p>
                                </>
                            :(props.pathname.length !== 0 && props.pathname.url_path !== 'wrenews' && props.pathname.url_path !== 'jw&!$329654') ?
                                <>
                                    <img src={`${config.mainUrl}${props?.partner?.logo}`} alt="Logo" className="" style={{ width: '110px', height: '68px', objectFit: 'contain', }}></img>
                                    <p className="px-2 m-0">+</p>
                                </>
                                :
                                ''
                            }
                            <img src="/assets/logos/Color_H.png" alt="Logo" width="142px" height="45px"></img>
                        </div>
                    </Typography>
                </div>
                <div className="col-5 d-flex justify-content-end align-items-center jost-bold ipad-res" >
                    <div className="w-100 d-flex justify-content-between align-items-center global-nav">
                        <Link activeclass="active"
                            className="NavHeader"
                            to="trade"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerHowItWorks("HOW IT WORKS", 1) }}
                            duration={500}>
                            HOW IT WORKS
                        </Link>
                        <Link activeclass="active"
                            to="faq"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { GAEventTrackerFaq("FAQs", 1) }}
                            duration={500}>
                            FAQs
                        </Link>
                        {/* <Link activeclass="active"
                            to="/calculator"
                            spy={true}
                            smooth="true"
                            offset={-70}
                            onClick={(e) => { handleCalculator() }}
                            duration={500}>
                            CALCULATOR
                        </Link> */}
                        <Button
                            variant="contained"
                            disableelevation="true"
                            onClick={(e) => { GAEventTrackerContact("Contact Us", 1); handleClickOpen2() }}
                            style={{ color: 'white', backgroundColor: `${props.partner.secondary_color ? props.partner.secondary_color : '#2A83C2'}` }}
                        >
                            Contact
                        </Button>
                    </div>
                </div>
            </Toolbar>
        )
    }

    useEffect(() => {
        document.addEventListener('click', function (e) {
            setDrawerState(false)
        });
    })

    useEffect(() => {
        const setResponsiveness = () => {
            return window.innerWidth < 770
                ? setState((prevState) => ({ ...prevState, mobileView: true }))
                : setState((prevState) => ({ ...prevState, mobileView: false }));
        };
        setResponsiveness();
        window.addEventListener("resize", () => setResponsiveness());
    }, []);

    function Contactus() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h3 className="headerfont">Contact Us</h3>
                                <div className="contentfonthead">To speak with a Calque representative, call</div>
                                <div className="contentfont">
                                    <a className="tel" href={`tel:${props?.contactGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.contactGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Or send an email to</div>
                                <div className="contentfont">
                                    <a className="mailto" href={`mailto:${props?.emailGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.emailGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Our address is</div>
                                <div className="contentfont">
                                    <b>
                                        <p className="contactAddress">
                                            {props?.addressGlobal?.application_config_value}
                                        </p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <AppBar className={header}>
            {mobileView ? mobileNav() : desktopNav()}
            <Modalpopup open={openSubmit} handleClickOpen={handleClickOpen2} contact={Contactus()} />
        </AppBar>
    );
}
